import { Injectable, OnDestroy } from '@angular/core';
import { ConfigService } from '../config.service';
import { AuthService } from '../auth/auth.service';
import { ToastrService } from 'ngx-toastr';
import { NotificacionesService } from '../notificacion/notificacion.service';
import Echo from 'laravel-echo';
import Pusher from 'pusher-js';

declare global {
  interface Window {
    Pusher: typeof Pusher;
    Echo: Echo;
  }
}

@Injectable({
  providedIn: 'root'
})
//PM CATFER-54 services para realizar la conexion y union al grupo en socket que se utilizara para las notificaciones en tiempo real.
export class SocketConnectionService implements OnDestroy {
  private echo: Echo;

  constructor(
    private authService: AuthService,
    private toast: ToastrService,
    private notificacionesService: NotificacionesService,
    private configService: ConfigService
  ) {
    window.Pusher = Pusher; 
  }

  // MC CATFER-135 Método que inicializa la conexión con Echo y el canal de notificaciones
  InicializarConnection() {
    this.echo = new Echo({
      broadcaster: 'pusher',
      key: this.configService.config.servidor?.echo_config?.app_key,
      wsHost: this.configService.config.servidor?.echo_config?.host,
      wsPort: this.configService.config.servidor?.echo_config?.port,
      cluster: this.configService.config.servidor?.echo_config?.cluster,
      forceTLS: false,
      enabledTransports: ['ws', 'wss'],
    });
    this.echo.connector.pusher.connection.bind('connected', () => {
      console.log('Conectado a Echo!');
      this.echo
        .channel(`C${this.authService.usuario.id_cliente}`)
        .listen('.RealtimeNotification', (message: any) => {
          this.toast.success(
            message.Mensaje ?? message.mensaje ?? 'Mensaje no disponible', 
            message.Titulo ?? message.titulo ?? 'Título no disponible', 
            {timeOut: 20000}
          );
          this.notificacionesService.refreshListado.next(true);
        });
    });
  }

  // MC CATFER-135 Método que retorna si la conexión con Echo está establecida
  isConnected(): boolean{
    const isConnected: boolean = this.echo !== undefined && this.echo.connector.pusher.connection.state === 'connected';
    return isConnected;
  }

  ngOnDestroy() {
		this.desconectarConnection();
  }

  // MC CATFER-135 Método que cierra la conexión con Echo
  desconectarConnection() {
    if (this.isConnected()){
      this.echo.disconnect();
      if (this.echo.connector.pusher.connection.state === 'disconnected') {
        console.log('Se cerró la conexión con Echo');
      }
    }
  }
}
